import { z } from "zod";
import {
  COMMENT,
  CRM_OPS_STATUS,
  REGION_HEAD_ID,
  RELATIONSHIP_MANAGER_ID,
  TARGET_DATE,
  NO_OF_WORKSTATIONS,
  SPECIAL_REQUIREMENTS,
  LAB_SETUP_STATUS,
} from "./consts";

// Form validation schema
export const schema = z.object({
  [TARGET_DATE]: z.string().min(1, "Target Date is required"),
  [NO_OF_WORKSTATIONS]: z
    .string({ invalid_type_error: "No of workstations must be a number" })
    .min(1, "At least 1 workstation is required"),
  [SPECIAL_REQUIREMENTS]: z.string().optional(),
  [LAB_SETUP_STATUS]: z.enum([
    "To-Do",
    "On Track",
    "Delayed",
    "Lab Done",
    "Stocking Done",
  ], {
    required_error: "Lab setup status is required",
  }),
  [COMMENT]: z.string().optional(),
});

export type FormValues = z.infer<typeof schema>;
